var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-loader d-flex align-center flex-grow-1 fill-height justify-center"},[_c('v-progress-circular',_vm._b({attrs:{"size":75,"indeterminate":""}},'v-progress-circular',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }